import React from 'react'
import { Box, Paper, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

type PoemErrorStateProps = {
  variant: 'notFound' | 'error'
}

const PoemErrorState: React.FC<PoemErrorStateProps> = ({ variant }) => {
  const { t } = useTranslation()

  const title =
    variant === 'notFound'
      ? t('poem.notFoundTitle', 'Gedicht nicht gefunden')
      : t('poem.errorTitle', 'Technischer Fehler')

  const message =
    variant === 'notFound'
      ? t('poem.notFoundMessage', 'Dieses Gedicht wurde gelöscht oder ist nicht mehr verfügbar.')
      : t('poem.errorMessage', 'Es ist ein technischer Fehler aufgetreten. Bitte versuche es später erneut.')

  return (
    <Box sx={{ py: 6 }}>
      <Paper
        elevation={3}
        sx={{
          maxWidth: 720,
          mx: 'auto',
          p: 4,
          textAlign: 'center',
          borderRadius: 3
        }}
      >
        <Typography variant="h5" sx={{ mb: 1, fontWeight: 700 }}>
          {title}
        </Typography>
        <Typography color="text.secondary" sx={{ mb: 3 }}>
          {message}
        </Typography>
      </Paper>
    </Box>
  )
}

export default PoemErrorState
